import {
  BASE_PERMISSIONS,
  BaseInquiryStatus,
  BaseDateService,
  BASE_DATE_SERVICE_FORMAT,
  BaseApplicationSectionsInterface,
  DEFAULT_PLANNING_BOARD_VIEW,
  PLANNING_BOARD_DEFAULT_PAGE_SIZE,
} from 'base';
import { AbsenceRequestStatusEnum } from '../../modules/absence-requests/_enums/absence-request-status.enum';

export const APPLICATION_SECTIONS_GROWTH: BaseApplicationSectionsInterface[] = [
  {
    id: 0,
    icon: 'fa-solid fa-fw fa-house',
    title: 'dashboard',
    url: '/dashboard',
    featurePermissionKeys: [],
    roleKeys: [],
  },
  {
    id: 1,
    icon: 'fa-solid fa-fw fa-user-plus',
    title: 'requests',
    url: '/inquiries/list',
    queryParams: { page: 1, status: BaseInquiryStatus.published },
    featurePermissionKeys: [],
    roleKeys: [],
  },
  {
    id: 2,
    icon: 'fa-solid fa-fw fa-person-circle-check',
    title: 'bookings.offersAndBookings',
    url: '/offers-and-bookings',
    queryParams: { page: 1 },
    featurePermissionKeys: [],
    roleKeys: [],
  },
  {
    id: 3,
    icon: 'fa-solid fa-fw fa-bullseye',
    title: 'operations.plural',
    url: '/assignments',
    queryParams: { page: 1, status: 'planned,active' },
    featurePermissionKeys: [BASE_PERMISSIONS.FEATURE_ADMIN_ASSIGNMENTS],
    roleKeys: [],
  },
  {
    id: 4,
    icon: 'fa-solid fa-fw fa-users',
    title: 'candidates.plural',
    url: '/employees',
    queryParams: { page: 1, active: 'true' },
    featurePermissionKeys: [BASE_PERMISSIONS.FEATURE_ADMIN_PROFILES],
    roleKeys: [],
  },
  {
    id: 5,
    icon: 'fa-solid fa-rectangle-list',
    title: 'timeRecordings.page',
    url: '/time-recordings/list',
    queryParams: {
      page: 1,
      period: `${BaseDateService.format(
        BaseDateService.getDateDaysAgo(7),
        BASE_DATE_SERVICE_FORMAT
      )},${BaseDateService.format(new Date(), BASE_DATE_SERVICE_FORMAT)}`,
    },
    featurePermissionKeys: [
      BASE_PERMISSIONS.FEATURE_ADMIN_ASSIGNMENT_DATES,
      BASE_PERMISSIONS.FEATURE_ADMIN_ASSIGNMENTS,
    ],
    roleKeys: [],
  },
  {
    id: 8,
    icon: 'fa-solid fa-fw fa-calendar-circle-minus',
    title: 'absenceRequests.title',
    url: '/absence-requests/list',
    queryParams: { page: 1, statuses: AbsenceRequestStatusEnum.PENDING },
    featurePermissionKeys: [BASE_PERMISSIONS.FEATURE_ADMIN_PROFILES],
    roleKeys: [],
  },
  {
    id: 6,
    icon: 'fa-solid fa-fw fa-table',
    title: 'planningBoard.title',
    url: '/planning-board',
    queryParams: {
      from: BaseDateService.format(BaseDateService.getStartOfCurrentWeek(), BASE_DATE_SERVICE_FORMAT),
      to: BaseDateService.format(BaseDateService.getEndOfCurrentWeek(), BASE_DATE_SERVICE_FORMAT),
      view: DEFAULT_PLANNING_BOARD_VIEW,
      size: PLANNING_BOARD_DEFAULT_PAGE_SIZE,
    },
    featurePermissionKeys: [],
    roleKeys: [],
  },
  {
    id: 7,
    icon: 'fa-solid fa-fw fa-building',
    title: 'location.customerPlural',
    url: '/customer-locations/list',
    queryParams: { page: 1 },
    featurePermissionKeys: [],
    roleKeys: [],
  },
];
